import { render, staticRenderFns } from "./page-head.vue?vue&type=template&id=f8f97740&scoped=true&"
import script from "./page-head.vue?vue&type=script&lang=js&"
export * from "./page-head.vue?vue&type=script&lang=js&"
import style0 from "./page-head.vue?vue&type=style&index=0&id=f8f97740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f97740",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
